import { render } from "./LoginSideImage.vue?vue&type=template&id=4b15c01b&ts=true"
import script from "./LoginSideImage.vue?vue&type=script&lang=ts"
export * from "./LoginSideImage.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_d3089a66/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__